"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SkeletonCatalogueMobile = require("./Mobile/SkeletonCatalogueMobile");
Object.keys(_SkeletonCatalogueMobile).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SkeletonCatalogueMobile[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SkeletonCatalogueMobile[key];
    }
  });
});
var _SkeletonMainCategoryMobile = require("./Mobile/SkeletonMainCategoryMobile");
Object.keys(_SkeletonMainCategoryMobile).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SkeletonMainCategoryMobile[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SkeletonMainCategoryMobile[key];
    }
  });
});
var _SkeletonCatalogueDesktop = require("./Desktop/SkeletonCatalogueDesktop");
Object.keys(_SkeletonCatalogueDesktop).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SkeletonCatalogueDesktop[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SkeletonCatalogueDesktop[key];
    }
  });
});
var _SkeletonMainCategoryDesktop = require("./Desktop/SkeletonMainCategoryDesktop");
Object.keys(_SkeletonMainCategoryDesktop).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SkeletonMainCategoryDesktop[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SkeletonMainCategoryDesktop[key];
    }
  });
});
